import React from 'react';
import Markdown from 'markdown-to-jsx';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import { CombinedImage } from '@ynap/image';

const bem = new BEMHelper('Notification');

const propTypes = {
    component: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    className: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    emphasis: PropTypes.string,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
    image: PropTypes.string,
    arrow: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
    arrowClassName: PropTypes.string,
    arrowStyle: PropTypes.object,
    messageChildren: PropTypes.node,
    onClose: PropTypes.func,
    children: PropTypes.node,
    forwardedRef: PropTypes.func,
    inlineAction: PropTypes.boolean,
    modifier: PropTypes.string,
    title: PropTypes.string,
    parseMarkdown: PropTypes.boolean,
    messageModifier: PropTypes.string,
};

const defaultProps = {
    component: 'div',
    type: 'info',
};

export default function Notification(props) {
    const {
        arrow,
        arrowClassName,
        arrowStyle,
        children,
        className,
        component: Component,
        emphasis,
        forwardedRef,
        image,
        inlineAction,
        message,
        messageChildren,
        messageModifier = null,
        modifier,
        name,
        onClose,
        parseMarkdown = false,
        title,
        type,
        ...rest
    } = props;

    return (
        <Component className={bem(null, [name, type, arrow, modifier], className)} ref={forwardedRef} {...rest}>
            {onClose ? (
                <button className={bem('close')} onClick={onClose} type="button">
                    ×
                </button>
            ) : null}
            {image && (
                <div className={bem('image')}>
                    <CombinedImage computeAttributes={false} imageSrcsetSize={image?.srcSet} src={image?.url || image} />
                </div>
            )}
            <div className={bem('details', type)}>
                {title && <span className={bem('title')}>{title}</span>}
                {ensureArray(message).map((m, index) => (
                        <span
                            key={index}
                            className={bem('message', [type, inlineAction ? 'inlineAction' : null, title ? 'withTitle' : null, messageModifier], emphasis)}
                        >
                            {parseMarkdown ? <Markdown options={{ forceInline: true }}>{m.trim()}</Markdown> : m}
                        </span>
                    ))}
                {messageChildren}
                {children && type && <div className={bem('actions', [type, inlineAction ? 'inlineAction' : null])}>{children}</div>}
            </div>
            {arrow ? <span className={bem('arrow', [type, arrow], arrowClassName)} style={arrowStyle} /> : null}
        </Component>
    );
}

Notification.propTypes = propTypes;
Notification.defaultProps = defaultProps;

function ensureArray(array) {
    return Array.isArray(array) ? array : [array];
}
